// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2-F2s","insightsList":"newBusinessInsightsMenu_insightsList__3uGyM","active":"newBusinessInsightsMenu_active__2JiAI"};